import { Injectable } from '@angular/core';
import { Maintenance } from 'mbs-ui-shared@components/maintenance-page/maintenance-page.models';
import { ConfigurationService } from 'mbs-ui-shared@services/configuration.service';
import moment from 'moment/moment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  public get maintenances(): Array<Maintenance> {
    return this.config.get('maintenances');
  }

  constructor(private config: ConfigurationService) {}

  public getMaintenance(pageUrl: string) {
    return (
      pageUrl &&
      this.maintenances?.find((maintenance) => {
        const pages = Array.isArray(maintenance.page) ? maintenance.page : [maintenance.page];
        const isSomeRouteUnderMaintenance = pages.some((page) => this.isRouteUnderMaintenance(pageUrl, page));

        return isSomeRouteUnderMaintenance && moment(new Date()).isBetween(maintenance.startDate, maintenance.endDate);
      })
    );
  }

  public getNotifications() {
    return this.maintenances?.filter((maintenance) => moment(new Date()).isBetween(maintenance.showAfter, maintenance.endDate));
  }

  private isRouteUnderMaintenance(route: string, mask: string) {
    if (mask.endsWith('/*')) {
      const isChildRouteUnderMaintenance = route.startsWith(mask.slice(0, -1));
      const isRootRouteUnderMaintenance = route === mask.slice(0, -2);

      return isChildRouteUnderMaintenance || isRootRouteUnderMaintenance;
    } else {
      return route === mask;
    }
  }
}
